import {IAppSpec} from "../../../../Redux/selector.state";
import {AcceptorOutputFn} from "../../../../models/acceptor/IAcceptor";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {currentBoundFromPower, minPFCVout, roundToEffectiveValue} from "../../../../models/utils_specs";
import {Ic} from "../../../../models/common";
import {Acceptor_Common} from "../../../../models/acceptor/acceptor_common";

export class Acceptor_AcDc_PFC extends Acceptor_Common {

  private acceptSingle_PFC_Vout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single voltage output is defined and inside the bounds */

    const maxInput: number = (spec.spec.value.input) && Utils.isValueReal(spec.spec.value.input.max) ? spec.spec.value.input.max : NaN;

    const _minPFCVout: number = "stnrgpf01" === a.CPN.toLowerCase()
      ? minPFCVout(maxInput, 0.07)
      : minPFCVout(maxInput, 0.05);

    const voutMin: number = Utils.isValueReal(_minPFCVout) ? Math.max(a.vout_min, _minPFCVout) : a.vout_min;

    // console.log("PFC Vout" + a.topology + "-" + a.CPN, voutMin, "<=", out.voltage, "<=", a.vout_max);

    const ret = (Utils.isValueEmpty(out.voltage)) || ((voutMin <= out.voltage && out.voltage <= a.vout_max));
    return ret;
  }

  private acceptSingle_PFC_Iout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* ho creato Utils.getNumberDefaultable da mettere tra le funzioni globali */
    /* occorre creare  ValueFormatter class*/

    const bound = currentBoundFromPower(a, out);

    // console.log("PFC Iout" + a.topology + "-" + a.CPN, bound.min, "<=", out.current, "<=", bound.max);

    /* check if single current output is defined and inside the bounds */
    const ret = (Utils.isValueEmpty(out.current)) || ((bound.min <= out.current && out.current <= bound.max));
    return ret;
  }

  protected singleOutputV(): AcceptorOutputFn {return this.acceptSingle_PFC_Vout;}
  protected singleOutputI(): AcceptorOutputFn {return this.acceptSingle_PFC_Iout;}


}
